import PropTypes from 'prop-types';

export const Package = PropTypes.shape({
    packageId: PropTypes.string.isRequired,
    name: PropTypes.string,
    type: PropTypes.string,
});

export default Package;
